<template>
  <div class="px-20px py-25px flex-1 flex flex-col" v-loading="loading">
    <div class="text-21px text-black font-bold flex">
      <span class="flex-1">
        {{ discussDetail.title }}
      </span>
      <el-button @click="$emit('back')">返回</el-button>
    </div>
    <div class="flex items-center py-15px text-19px text-default">
      <avatar v-if="discussDetail.avatar" :src="discussDetail.avatar" class="w-21px h-21px" />
      <span class="ml-10px">{{ discussDetail.user_name }}</span>
      <span class="ml-40px">{{ discussDetail.views }} 浏览 <span class="mx-5px">|</span>{{ discussDetail.reply_count }}
        回复</span>
      <span class="ml-25px">{{ discussDetail.create_at }}</span>
    </div>
    <div class="text-19px py-10px" v-html="discussDetail.cotent"></div>
    <div class="w-full min-h-50px flex-1">
      <template v-if="replyLists.length > 0">
        <div class="px-25px pt-10px pb-20px text-19px mb-20px" style="background: #f9f9f9"
          v-for="(item, index) in replyLists" :key="index">
          <div class="w-full flex items-center">
            <avatar v-if="item.avatar" :src="item.avatar" class="w-32px h-32px" />
            <span class="text-black ml-10px">{{ item.user_name }}</span>
            <span class="ml-20px flex-1">{{ item.create_at }}</span>

            <!-- <div v-if="hasPer()">
              <el-button type="text" class="px-10px" v-if="hasPer(item.user_id)"
                >编辑</el-button
              >
              <span>|</span>
            </div> -->
            <el-button type="text" class="px-10px" @click="reply(item)" v-if="hasPer()">回复</el-button>
            <el-dropdown class="ml-5px" trigger="click" @command="dropdown" v-if="hasPer()">
              <span class="el-dropdown-link">
                <i class="el-icon-more"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="hasPer(item.user_id)"
                  :command="beforeCommand('delete', item)">删除</el-dropdown-item>
                <el-dropdown-item :command="beforeCommand('report', item)">举报</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="flex py-10px">
            <div class="w-3px ml-15px mr-20px" style="background: #9d97b0" v-if="item.father_id"></div>
            <div v-html="item.father_id ? item.father_content : item.content"></div>
          </div>
          <div class="text-black mt-10px" v-html="item.content" v-if="item.father_id"></div>
        </div>
      </template>
      <template v-else>
        <div class="text-center h-100px pt-40px text-grey">暂无回复……</div>
      </template>
    </div>

    <el-pagination class="h-53px flex items-center justify-center" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="pageSizes" :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total" hide-on-single-page>
    </el-pagination>

    <editor-vue v-model="replyData" :placeholder="replyItem ? `回复：${replyItem.user_name}` : '回复一下吧'" v-if="hasPer()" />

    <el-button class="w-117px mt-15px" type="primary" :loading="replyLoading" @click="replyConfirm"
      v-if="hasPer()">回复</el-button>
  </div>
</template>

<script>
import EditorVue from '@/components/editor-vue.vue'
import dayjs from 'dayjs'
import hasPer from '@/utils/hasPermission'
import avatar from '@/components/avatar.vue'

export default {
  components: { EditorVue, avatar },
  props: { data: {} },
  data() {
    return {
      hasPer,
      loading: false,
      replyLoading: false,
      replyLists: [],
      pageNo: 1,
      pageSize: 10,
      pageSizes: [10, 20, 30, 40, 50, 100],
      total: 0,
      replyItem: null, // 当前回复的讨论
      replyData: ''
    }
  },
  computed: {
    discussDetail() {
      return this.$props.data
    }
  },
  created() {
    this.getReplies()
  },
  mounted() { },
  methods: {
    // 查询回复lists
    getReplies() {
      this.loading = true
      this.$api.project
        .discusslist({
          baseReq: {
            page: this.pageNo,
            pageSize: this.pageSize
          },
          issue_id: this.discussDetail.id
        })
        .then((res) => {
          const { message } = res
          if (message === 'Success') {
            const arr = res.data.list
            arr.forEach((item) => {
              item.create_at = dayjs(item.create_at).format(
                'YYYY-MM-DD HH:mm:ss'
              )
            })
            this.replyLists = arr
            this.total = res.data.page.allCount
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 回复列表右上角回复按钮点击事件
    reply(data) {
      this.replyItem = data
    },
    // 确认回复
    replyConfirm() {
      this.replyLoading = true
      this.$api.project
        .creatediscuss({
          content: this.replyData,
          issue_id: this.discussDetail.id, // 问题id
          pid: this.replyItem ? this.replyItem.id : 0 // 回复的讨论id（如果是回复问题的就传0）
        })
        .then((res) => {
          const { message } = res
          if (message === 'Success') {
            this.replyData = ''
            this.getReplies() // 更新list
          }
        })
        .finally(() => {
          this.replyLoading = false
        })
    },
    beforeCommand(flag, data) {
      return { flag, data }
    },
    dropdown(command) {
      const { flag, data } = command
      if (flag === 'delete') {
        this.deleteReply(data.id)
      }
    },
    // 删除评论
    deleteReply(replayId) {
      this.$confirm(`确认删除此讨论？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.project
          .removediscuss({
            id: replayId
          })
          .then((res) => {
            const { message } = res
            if (message === 'Success') {
              this.$message.success('删除成功！')
              this.getReplies() // 更新list
            }
          })
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNo = 1
      this.getReplies()
    },
    handleCurrentChange(val) {
      this.pageNo = val
      this.getReplies()
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
